export default __webpack_public_path__ + "img/series-5-gold 2.png";